import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var avatarBlockComponentName = 'QuantumAvatarBlock';
export function getAvatarBlockUtilityClass(slot) {
    return generateUtilityClass(avatarBlockComponentName, slot);
}
export var avatarBlockClasses = generateUtilityClasses(avatarBlockComponentName, [
    'root',
    'avatar',
    'titleBlock',
    'endAdornment',
]);
